import React from 'react';
import {Skeleton} from 'antd';
import styled from 'styled-components';
import {mediaScreenSizes} from '../../../utils/constans/styles/screenSizes';

const SkeletonCardWrapper = styled.div`
  background: #FAFAFA;
  border: 1px solid #D9D9D9;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const SkeletonHeader = styled.div`
  background: #FAFAFA;
  display: flex;
  gap: 21px;
  align-items: center;
  border-radius: 12px 12px 0 0;
`;

const SkeletonMainRow = styled.div`
  display: flex;
  gap: 21px;
  align-items: center;
  width: 100%;

  @media (max-width: 1360px) {
    flex-wrap: wrap;
  }
`;

const SkeletonVerticalDivider = styled.div`
  width: 1px;
  height: 50px;
  background: #D9D9D9;
  flex-shrink: 0;
`;

const SkeletonLargeScreenDivider = styled(SkeletonVerticalDivider)`
  @media (max-width: 1360px) {
    display: none;
  }
`;

const SkeletonBrokerInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  width: 118.834px;
`;

const SkeletonRouteSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 173px;
`;

const SkeletonPaxSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 36px;
  align-self: flex-start;
`;

const SkeletonJetsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 133px;
  align-self: flex-start;
`;

const SkeletonActionsSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding-left: 50px;
  
  @media(max-width: ${mediaScreenSizes.mobile}) {
    padding-left: 0;
  }

  @media (min-width: 651px) and (max-width: 1360px) {
    order: -2;
    padding-left: 0;
  }

  @media (max-width: 650px) {
    order: 1;
    justify-content: flex-end;
    width: 100%;
  }
`;

export const OrderCharterCardSkeleton: React.FC = () => {
  return (
    <SkeletonCardWrapper>
      <SkeletonHeader>
        <SkeletonMainRow>
          {/* Broker Info Section */}
          <SkeletonBrokerInfo>
            <Skeleton.Input active size="small" style={{ width: 90, height: 12 }} />
            <Skeleton.Input active size="small" style={{ width: 100, height: 22 }} />
            <Skeleton.Input active size="small" style={{ width: 110, height: 12, marginTop: 2 }} />
          </SkeletonBrokerInfo>

          {/* Chat Button */}
          <Skeleton.Button active size="small" shape="circle" style={{ width: 35, height: 35, minWidth: 35 }} />

          <SkeletonVerticalDivider />

          {/* Order Type Section */}
          <div style={{ width: 78 }}>
            <Skeleton.Button active size="small" style={{ width: 78, height: 32 }} />
          </div>

          <SkeletonLargeScreenDivider />

          {/* Route Section */}
          <SkeletonRouteSection>
            <Skeleton.Input active size="small" style={{ width: 120, height: 17 }} />
            <Skeleton.Input active size="small" style={{ width: 150, height: 17 }} />
            <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
              <Skeleton.Input active size="small" style={{ width: 12, height: 12 }} />
              <Skeleton.Input active size="small" style={{ width: 60, height: 13 }} />
            </div>
          </SkeletonRouteSection>

          <SkeletonVerticalDivider />

          {/* PAX Section */}
          <SkeletonPaxSection>
            <Skeleton.Input active size="small" style={{ width: 30, height: 13 }} />
            <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
              <Skeleton.Input active size="small" style={{ width: 14, height: 14 }} />
              <Skeleton.Input active size="small" style={{ width: 10, height: 14 }} />
            </div>
          </SkeletonPaxSection>

          <SkeletonVerticalDivider />

          {/* Jets Status Section */}
          <SkeletonJetsSection>
            <Skeleton.Input active size="small" style={{ width: 35, height: 13 }} />
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <Skeleton.Button active size="small" shape="circle" style={{ width: 24, height: 24, minWidth: 24 }} />
              <Skeleton.Input active size="small" style={{ width: 60, height: 14 }} />
            </div>
            <Skeleton.Input active size="small" style={{ width: 80, height: 14 }} />
          </SkeletonJetsSection>

          <SkeletonLargeScreenDivider />

          {/* Actions Section */}
          <SkeletonActionsSection>
            <Skeleton.Button active size="small" style={{ width: 45, height: 35, minWidth: 45 }} />
            <Skeleton.Button active size="small" style={{ width: 45, height: 35, minWidth: 45 }} />
            <Skeleton.Button active size="small" shape="circle" style={{ width: 28, height: 27, minWidth: 28 }} />
          </SkeletonActionsSection>
        </SkeletonMainRow>
      </SkeletonHeader>
    </SkeletonCardWrapper>
  );
};

